import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { useCatalog } from "../contexts/CatalogContext";

export default function FloatingActions() {
  const { CONTACT } = useCatalog();

  return (
    <>
      {/* WhatsApp float */}
      <a
        href={CONTACT.whatsappLink}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp-btn"
        aria-label="Chat on WhatsApp"
        className="fixed right-4 z-30 bg-[#22C55E] hover:bg-[#16A34A] text-white rounded-full p-4 shadow-lg transition-transform hover:scale-105 bottom-20 sm:bottom-6"
      >
        <MessageCircle className="w-6 h-6" />
      </a>

      {/* Mobile sticky call bar */}
      <a
        href={CONTACT.phoneLink}
        data-testid="mobile-call-now-bar"
        className="sm:hidden fixed left-0 right-0 bottom-0 z-30 bg-[#1A3C6E] text-white py-3 px-4 flex items-center justify-center gap-2 font-semibold shadow-2xl"
      >
        <Phone className="w-5 h-5" /> Call Now — {CONTACT.phone}
      </a>
    </>
  );
}
